enum OverlayType {
  Highlight = 0,
  Redaction = 1
}

export default OverlayType;
